import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, GlobeIcon, LockIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { Countdown } from './Countdown';
import { images, offerExtras } from '../data/content';
const TOTAL_SPOTS = 100;
const START_SPOTS = 7;
const MIN_SPOTS = 3;
export function Offer() {
  const [spots, setSpots] = useState(START_SPOTS);
  useEffect(() => {
    const id = window.setInterval(() => {
      setSpots(s => s > MIN_SPOTS ? s - 1 : s);
    }, 45000);
    return () => window.clearInterval(id);
  }, []);
  const filled = (TOTAL_SPOTS - spots) / TOTAL_SPOTS * 100;
  return <section id="offer" className="bg-brand-950 px-4 py-16 sm:py-24" aria-labelledby="offer-title" data-id="element-200" data-mp="yxxydxductpc">
      <div className="mx-auto max-w-2xl" data-id="element-201" data-mp="2fc68gshfdak3">
        <div className="text-center" data-id="element-202" data-mp="2fb4v2hcxsbz7">
          <p className="text-sm font-bold uppercase tracking-wider text-gold-light" data-id="element-203" data-mp="2feakxyte3hvz">Special launch offer</p>
          <h2 id="offer-title" className="mt-3 font-serif text-[32px] font-bold leading-[1.12] text-white sm:text-5xl" data-id="element-204" data-mp="2affse55meeyo">
            Here’s everything you’ll receive today
          </h2>
        </div>

        <div className="mt-10 overflow-hidden rounded-3xl bg-white shadow-2xl" data-id="element-205" data-mp="ul4tfkznir4m">
          <img src={images.deck} alt="Apometry Practice Deck full package" className="w-full bg-cream px-2 pt-4" data-id="element-206" data-mp="zgagin4sibua" />

          <div className="px-5 pb-8 pt-6 sm:px-8" data-id="element-207" data-mp="13hnn4zfpij29">
            <ul className="divide-y divide-brand-100" data-id="element-208" data-mp="6v0tbnlo99id">
              <li className="flex items-center justify-between gap-4 py-3" data-id="element-209" data-mp="bstzwhqw05j6">
                <div data-id="element-210" data-mp="bqpxk48mzel0">
                  <p className="font-bold text-ink" data-id="element-211" data-mp="fuffwbypwzxl">Apometry Practice Deck™</p>
                  <p className="text-sm text-muted" data-id="element-212" data-mp="fsb83ixp7gs1">6 Premium Volumes</p>
                </div>
                <span className="shrink-0 text-sm font-semibold text-muted line-through" data-id="element-213" data-mp="kn8oxc17yufh">$97</span>
              </li>
              <li className="flex items-center justify-between gap-4 py-3" data-id="element-214" data-mp="3oa7mf3zfbpod">
                <div data-id="element-215" data-mp="3o84lhowqgc4v">
                  <p className="font-bold text-ink" data-id="element-216" data-mp="vfqvhxndb4q3">5 Exclusive Bonuses</p>
                  <p className="text-sm text-muted" data-id="element-217" data-mp="vdnwwp85g39r">Journal, Selector, Home Kit & more</p>
                </div>
                <span className="shrink-0 text-sm font-semibold text-muted line-through" data-id="element-218" data-mp="qetfnrptymrr">$197</span>
              </li>
            </ul>

            <ul className="mt-3 grid gap-x-6 gap-y-2 rounded-2xl bg-brand-50 p-4 sm:grid-cols-2" data-id="element-219" data-mp="105xlo1xj2xag">
              {offerExtras.map(item => <li key={item} className="flex items-start gap-2 text-[15px] font-medium text-ink/85" data-id="element-220" data-mp="ch4wcobevnot">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-cta" aria-hidden="true" data-id="element-221" data-mp="7jmmmvpkl4fr" />
                  {item}
                </li>)}
            </ul>

            <div className="mt-6 text-center" data-id="element-222" data-mp="hf6e95x3pgyp">
              <p className="text-sm font-semibold uppercase tracking-wide text-muted" data-id="element-223" data-mp="1wwq06v4tcha4">
                Total value: <span className="text-danger line-through" data-id="element-224" data-mp="1sv4tjrivgz8d">$294+</span>
              </p>
              <p className="mt-2 text-sm font-bold uppercase tracking-wide text-brand-700" data-id="element-225" data-mp="1sxh6trdoqlf3">Today you get everything for</p>
              <p className="mt-1 font-serif text-7xl font-bold leading-none text-brand-800 sm:text-8xl" data-id="element-226" data-mp="25dgymelgxrsq">
                <span className="align-top text-3xl sm:text-4xl" data-id="element-227" data-mp="1qgzlbhtpy33j">$</span>27
                <span className="ml-1 font-sans text-xl font-bold text-muted" data-id="element-228" data-mp="1qiu4orpcdn5i">USD</span>
              </p>
              <p className="mt-3 text-sm font-semibold text-ink/80" data-id="element-229" data-mp="2j55624krvs3d">
                One-time payment · Lifetime access · No monthly fees · Instant download
              </p>
              <p className="mx-auto mt-3 flex max-w-md items-start justify-center gap-2 rounded-xl bg-cream px-3 py-2 text-left text-[13px] text-muted" data-id="element-230" data-mp="2o6b1491wnrg2">
                <GlobeIcon className="mt-0.5 h-4 w-4 shrink-0 text-brand-600" aria-hidden="true" data-id="element-231" data-mp="2edn53gir1rie" />
                <span data-id="element-232" data-mp="323r6ricdnh6r">
                  <strong className="text-ink" data-id="element-233" data-mp="322g63re8apjv">Automatic currency conversion:</strong> the price is converted to your local
                  currency at checkout.
                </span>
              </p>
            </div>

            <div className="mt-6 rounded-2xl border border-danger/25 bg-[#FCEEEC] p-4" data-id="element-234" data-mp="1j4bfndgbhthf">
              <div className="flex items-center justify-between gap-3 text-sm font-bold" data-id="element-235" data-mp="1e605t2q0viz7">
                <span className="flex items-center gap-2 text-danger" data-id="element-236" data-mp="198qjhvxxjnfl">
                  <span className="h-2 w-2 rounded-full bg-danger animate-live-dot" aria-hidden="true" data-id="element-237" data-mp="149x7y927e6i2" />
                  Only {spots} spots left at $27
                </span>
                <span className="text-ink/70" data-id="element-238" data-mp="1wy2t2wx65xif">{Math.round(filled)}% claimed</span>
              </div>
              <div className="mt-2.5 h-3.5 w-full overflow-hidden rounded-full bg-white" role="progressbar" aria-valuenow={Math.round(filled)} aria-valuemin={0} aria-valuemax={100} aria-label="Promotional spots claimed" data-id="element-239" data-mp="1s6t4lzncx084">
                <motion.div className="h-full rounded-full bg-danger" initial={{
                width: '80%'
              }} animate={{
                width: `${filled}%`
              }} transition={{
                duration: 0.3,
                ease: [0.23, 1, 0.32, 1]
              }} data-id="element-240" data-mp="2fvviqxis8axv" />
              </div>
              <p className="mt-2 text-[13px] text-ink/70" data-id="element-241" data-mp="2x4y6u0mq94ve">
                When these spots run out, the promotional price is no longer guaranteed.
              </p>
            </div>

            <div className="mt-6" data-id="element-242" data-mp="374yrbpwc1r16">
              <CtaButton label="I want the Apometry Practice Deck™" data-id="element-243" data-mp="373x2mime960z" />
              <p className="mt-3 flex items-center justify-center gap-1.5 text-center text-sm text-muted" data-id="element-244" data-mp="3b4pc9cz6hcxs">
                <LockIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-245" data-mp="3fxs8xtz952i7" />
                One-time payment of $27 · Instant download · Lifetime access · 7-day guarantee
              </p>
              <Countdown data-id="element-246" data-mp="3pvg60qkbym3j" />
            </div>
          </div>
        </div>

        <p className="mx-auto mt-8 max-w-xl text-center text-[16px] leading-relaxed text-brand-100" data-id="element-247" data-mp="3utrhf5q9x4nv">
          For $27, you’ll have 30 guided practices you can return to whenever you want to practice — without having to
          search through dozens of videos or decide what to do from scratch.
        </p>
      </div>
    </section>;
}